import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Cancelacion.css'; // Este archivo contiene el estilo específico

const Cancelacion = () => {
  const navigate = useNavigate();

  return (
    <div className="cancelacion-container">
      <div className="cancelacion-card">
        <h1 className="cancelacion-titulo">❌ Pago cancelado</h1>
        <p className="cancelacion-subtitulo">Tu reserva no se ha completado.</p>
        <p>Si fue un error, puedes intentarlo de nuevo.</p>
        <button
          className="cancelacion-boton"
          onClick={() => navigate('/servicios/reserva-pistas')}
        >
          Volver a intentar
        </button>
      </div>
    </div>
  );
};

export default Cancelacion;
